import COATypeApi from "./COATypeApi";

export default COATypeApi;